import { AxiosResponse } from "axios";
import { axiosInstance } from "./axiosInstance";
import { RotationDTO, RotationUpdateBody, SiblingSchedulesDTO } from "../../models/RotationDTO";
import { ScheduleChangeBody, ScheduleChangeDTO } from "../../models/ScheduleChangeDTO";

const RESOURCE_URL_V2 = "/admin/campus/";

/** Alumno rotativo: sibling schedules and the authorized-schedules set of an enrollment. */
export class RotationService {

	/** Schedules of the same módulo + periodo as `scheduleId`, usable as authorized schedules. */
	getSiblings = async (campusId: number, scheduleId: number): Promise<AxiosResponse<SiblingSchedulesDTO>> => {
		const uri = `${RESOURCE_URL_V2}${campusId}/enrollments/_siblings?scheduleId=${scheduleId}`;
		return axiosInstance.get<SiblingSchedulesDTO>(uri);
	}

	getRotation = async (campusId: number, studentId: number, enrollmentId: number): Promise<AxiosResponse<RotationDTO>> => {
		const uri = `${RESOURCE_URL_V2}${campusId}/students/${studentId}/enrollments/${enrollmentId}/_rotation`;
		return axiosInstance.get<RotationDTO>(uri);
	}

	/** 400 `{message}` when a schedule is not a sibling of the home schedule. */
	updateRotation = async (campusId: number, studentId: number, enrollmentId: number, body: RotationUpdateBody): Promise<AxiosResponse<RotationDTO>> => {
		const uri = `${RESOURCE_URL_V2}${campusId}/students/${studentId}/enrollments/${enrollmentId}/_rotation`;
		return axiosInstance.put<RotationDTO>(uri, body);
	}

	/** Cambio de horario: current schedule, the schedules it can move to and the change history. */
	getScheduleChange = async (campusId: number, studentId: number, enrollmentId: number): Promise<AxiosResponse<ScheduleChangeDTO>> => {
		const uri = `${RESOURCE_URL_V2}${campusId}/students/${studentId}/enrollments/${enrollmentId}/_schedule`;
		return axiosInstance.get<ScheduleChangeDTO>(uri);
	}

	/** 422 `{message}` when the move is not allowed. Keeps the enrollment and its payment plan. */
	changeSchedule = async (campusId: number, studentId: number, enrollmentId: number, body: ScheduleChangeBody): Promise<AxiosResponse<ScheduleChangeDTO>> => {
		const uri = `${RESOURCE_URL_V2}${campusId}/students/${studentId}/enrollments/${enrollmentId}/_schedule`;
		return axiosInstance.put<ScheduleChangeDTO>(uri, body);
	}
}

/** Standalone instance: HttpManager is being edited by a parallel feature, so this service is not registered there yet. */
const rotationService = new RotationService();

export default rotationService;
